import { scaleLinear } from 'd3-scale';

export const getSegmentWidth = (
  value: number,
  min: number,
  max: number,
  containerWidth: number,
): number => {
  if (min === max) {
    return value >= max ? containerWidth : 0;
  }

  const segmentScale = scaleLinear()
    .domain([min, max])
    .range([0, containerWidth])
    .clamp(true);

  return segmentScale(value);
};
